import React, { PropTypes } from 'react'
import './style.less'

function CenterRow({ headline, children }) {
  return (
    <div className="row center-xs center-row">
      <div className="col-xs-12 col-sm-10">
        {headline && <h2>{headline}</h2>}
        {children && <p>{children}</p>}
      </div>
    </div>
  )
}

CenterRow.propTypes = {
  headline: PropTypes.string,
  children: PropTypes.node
}

CenterRow.defaultProps = {
  headline: null,
  children: null
}

export default CenterRow



// WEBPACK FOOTER //
// ../components/CenterRow/index.js